<script setup>
import { useRouter } from 'vue-router'

const props = defineProps({
  text: { type: String, required: true },
  to: { type: Object, default: null },
})

const router = useRouter()
const onClick = () => { if (props.to) router.push(props.to) }
</script>

<template>
  <span
    class="signal-label text-grey-6"
    :class="{ 'signal-label--link': to }"
    :role="to ? 'link' : undefined"
    @click="onClick"
  >{{ text }}<slot /></span>
</template>

<style scoped>
.signal-label {
  font-size: 0.6875rem;
  line-height: 1;
  white-space: nowrap;
}
.signal-label--link {
  cursor: pointer;
}
.signal-label--link:hover {
  text-decoration: underline;
}
</style>
